import React, { useEffect, useRef } from "react";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import HistoryTabs from "../components/HistoryTabs";
import historyIcon from "../assets/images/0_History/history_icon.png";
import "../index.css"

const History = () => {
    document.title = "History | MTA 20-Year-Needs Assessment";
    const headerRef = useRef(null);
    const divRef = useRef(null);
    const bodyId = document.querySelector("body").id;
    const bgImg = "https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/37c78a0a-6813-4e78-76b4-7acd15308300/width=2000";
    if (bodyId !== "history-page") {
        document.querySelector("body").id = "history-page";
    }

    useEffect(() => {
        const header = headerRef.current;
        const banner = header.querySelector("img");
        const div = divRef.current;
        header.style.backgroundImage = `url(${bgImg})`;

        if (banner) {
            banner.style.left = "-1800%";
            banner.style.position = "absolute";
        }

        const handleResize = () => {
            if (window.innerWidth > 992) {
                header.style.height = `100vh`;
                const ht = div.offsetHeight;
                const spanHeight = div.querySelector("span").offsetHeight;
                const h2Height = div.querySelector("h2").offsetHeight;
                const ht2 = spanHeight + h2Height;
                header.style.marginBottom = `${ht - ht2 - 70}px`;
                div.style.bottom = `${-(ht - ht2) + 140}px`;
                div.style.position = "absolute";
            } else {
                header.style.height = "auto";
                header.style.paddingTop = "40%";
                div.style.position = "relative";
            }
        };

        handleResize();

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div id="container">
            <NavBar showNavBar={true} pageTitle={<h1>20-Year Needs Assessment | <strong>History</strong></h1>} isSubpage={true} />
            <main id="content">
                <div className="subpage-header" ref={headerRef}>
                    <img src={bgImg} alt="Aerial view of the Bronx-Whitestone Bridge in 1939." />

                    <div ref={divRef}>
                        <span>
                            <img src={historyIcon} alt="" aria-hidden="true" />
                            Our History
                        </span>

                        <h2>New York has demonstrated throughout its history that investment in transit is the key to unlocking economic growth for the region&mdash;and that failure to do so has dire consequences</h2>

                        <p className="p2">Now it's our turn to confront upcoming challenges and secure the future for the next generation.</p>
                    </div>
                </div>
                <div className="row" id="history-row">
                    <em id="history-instruction">Click on the decades to explore our history.</em>
                    <div className="col-md-12">
                        <HistoryTabs />
                    </div>
                </div>
            </main>
            <Footer initialIsHome={false} />
        </div>
    );
};

export default History;


